import { render, staticRenderFns } from "./SpecificationAddPage.vue?vue&type=template&id=83cba312&scoped=true&"
import script from "./SpecificationAddPage.vue?vue&type=script&lang=js&"
export * from "./SpecificationAddPage.vue?vue&type=script&lang=js&"
import style0 from "./SpecificationAddPage.vue?vue&type=style&index=0&id=83cba312&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cba312",
  null
  
)

export default component.exports